module.exports = __webpack_public_path__ + "img/answer_head.621fb1a7.png";